var r = /* @__PURE__ */ ((e) => (e.Always = "always", e.Never = "never", e.Adaptive = "adaptive", e))(r || {}), c = /* @__PURE__ */ ((e) => (e.Medium = "medium", e.Small = "small", e))(c || {}), y = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.PrimaryDestructive = "primaryDestructive", e.PrimarySuccess = "primarySuccess", e.Secondary = "secondary", e.SecondaryDestructive = "secondaryDestructive", e.SecondarySuccess = "secondarySuccess", e))(y || {});
export {
  r as FullWidthEnum,
  c as SizesEnum,
  y as VariantsEnum
};
